import angular from 'angular';
import camelcaseKeys from 'camelcase-keys';
import { upperCase, first } from 'lodash';
import { angularComponent } from '@/legacy/helpers';

interface MyselfDto {
  firstName: string;
  lastName: string;
  role: string;
  roles: string[];
  sessionAutofinishAfter?: number;
  sessionAutofinishBefore?: number;
}

class AccountWidgetComponent {
  static $inject = ['$http', 'AuthService'];

  public user: MyselfDto|null = null;
  public abbrname: string|null = null;
  public userLoading: boolean = false;
  public dropdown: boolean = false;

  constructor(
    private $http: angular.IHttpService,
    private AuthService: any,
  ) {}

  public $onInit(): void {
    if (this.AuthService.isLoggedIn()) {
      this.loadUser();
    }
  }

  public async loadUser() {
    this.userLoading = true;

    try {
      const { data: user } = await this.$http.get('/api/myself');
      this.user = camelcaseKeys(user) as MyselfDto;
      this.abbrname = this.buildAbbrName(this.user);
    } finally {
      this.userLoading = false;
    }
  }

  public clearUser() {
    this.user = null;
    this.abbrname = null;
  }

  public logout() {
    this.AuthService.logout();
  }

  public toggleDropdown() {
    this.dropdown = !this.dropdown;
  }

  private buildAbbrName(u: MyselfDto|null): string|null {
    if (!u) {
      return null;
    }

    let abbr = String();

    if (u.firstName) {
      abbr += first(u.firstName)
    }

    if (u.lastName) {
      abbr += first(u.lastName)
    }

    return upperCase(abbr);
  }
}

angularComponent('accountWidget', {
  template: require('html-loader!./account-widget.component.html')['default'],
  controller: AccountWidgetComponent,
});